module.exports = __webpack_public_path__ + "img/Belgium.c484571f.png";